// extracted by mini-css-extract-plugin
export var aiStarIcon = "_mf-2";
export var container = "_mf-4";
export var dismissButton = "_mf-3";
export var hasPaddingBottom = "_mf-6";
export var last = "_mf-e";
export var scrollbarThumb = "_mf-c";
export var scrollbarTrack = "_mf-b";
export var selected = "_mf-9";
export var spin = "_mf-1";
export var spinning = "_mf-0";
export var suggestionItem = "_mf-d";
export var suggestionsPanel = "_mf-5";
export var tonePill = "_mf-8";
export var tonesContainer = "_mf-7";
export var unselected = "_mf-a";